/**
 * Auto-generated by tools/content-pipeline.
 * Pack: wordsearch-themedshape-v1
 * Item: wordsearch-films
 * Generated: 2026-06-06T03:02:12.128Z
 * Generator: google/gemini-2.5-flash  |  Judge: anthropic/claude-sonnet-4.5
 * Accepted: 57 items (judge threshold 0.70)
 * Edit this file by re-running the pipeline; do not hand-edit unless you know what you are doing.
 */
export const filmsWords = [
    {
        "word": "BOGART"
    },
    {
        "word": "GABLE"
    },
    {
        "word": "GARLAND"
    },
    {
        "word": "STEWART"
    },
    {
        "word": "WAYNE"
    },
    {
        "word": "TRACY"
    },
    {
        "word": "COOPER"
    },
    {
        "word": "GARBO"
    },
    {
        "word": "HEPBURN"
    },
    {
        "word": "BRANDO"
    },
    {
        "word": "NEWMAN"
    },
    {
        "word": "MONROE"
    },
    {
        "word": "BACALL"
    },
    {
        "word": "DOUGLAS"
    },
    {
        "word": "FONDA"
    },
    {
        "word": "GRANT"
    },
    {
        "word": "KELLY"
    },
    {
        "word": "EASTWOOD"
    },
    {
        "word": "REDFORD"
    },
    {
        "word": "STREEP"
    },
    {
        "word": "VERTIGO"
    },
    {
        "word": "REBECCA"
    },
    {
        "word": "NETWORK"
    },
    {
        "word": "PSYCHO"
    },
    {
        "word": "ROCKY"
    },
    {
        "word": "GREASE"
    },
    {
        "word": "HARVEY"
    },
    {
        "word": "BAMBI"
    },
    {
        "word": "FANTASIA"
    },
    {
        "word": "DRAMA"
    },
    {
        "word": "COMEDY"
    },
    {
        "word": "WESTERN"
    },
    {
        "word": "MUSICAL"
    },
    {
        "word": "MYSTERY"
    },
    {
        "word": "ROMANCE"
    },
    {
        "word": "THRILLER"
    },
    {
        "word": "HORROR"
    },
    {
        "word": "EPIC"
    },
    {
        "word": "REEL"
    },
    {
        "word": "SCREEN"
    },
    {
        "word": "MARQUEE"
    },
    {
        "word": "POPCORN"
    },
    {
        "word": "USHER"
    },
    {
        "word": "BALCONY"
    },
    {
        "word": "MATINEE"
    },
    {
        "word": "CAMERA"
    },
    {
        "word": "DIRECTOR"
    },
    {
        "word": "ACTOR"
    },
    {
        "word": "SCRIPT"
    },
    {
        "word": "OSCAR"
    },
    {
        "word": "STUDIO"
    },
    {
        "word": "SCENE"
    },
    {
        "word": "MOVIE"
    },
    {
        "word": "CINEMA"
    },
    {
        "word": "AUDIENCE"
    },
    {
        "word": "PREVIEW"
    },
    {
        "word": "TRAILER"
    }
];
//# sourceMappingURL=films.js.map